import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Document new/edit form -- direct-to-storage upload for the file field
// (card #4211, Playbooks video slice 1), so a large video does not pass
// through Puma. Mirrors the AIRLOCK dropzone and deck editor paste-upload
// patterns (DirectUpload straight from Stimulus), rather than Rails' native
// `file_field ..., direct_upload: true`.
//
// Why not the native helper: that helper intercepts the form's `submit`
// event, but this form's button calls `this.form.submit()` directly
// (app/views/documents/_form.html.erb), and a programmatic `.submit()` call
// never fires the `submit` event -- so the native interception would simply
// never run, and the file would go through Puma unchanged. Uploading on the
// file input's own `change` event sidesteps that entirely.
export default class extends Controller {
  static targets = ["input", "hiddenField", "status"]

  change(event) {
    const file = event.target.files?.[0]
    if (!file) return

    this.setStatus(`Uploading ${file.name}…`)

    const upload = new DirectUpload(file, this.directUploadUrl)
    upload.create((error, blob) => {
      if (error) {
        console.error("Document upload error:", error)
        this.setStatus(`Upload failed: ${error}`)
        return
      }

      // Swap the real file input (which would otherwise send the raw binary
      // through Puma) for the hidden field carrying the already-uploaded
      // blob's signed_id -- same name, so the controller sees one or the
      // other, never both.
      this.hiddenFieldTarget.disabled = false
      this.hiddenFieldTarget.value = blob.signed_id
      this.inputTarget.disabled = true

      this.setStatus(`${file.name} uploaded -- ready to submit.`)
    })
  }

  setStatus(text) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text || ""
  }

  get directUploadUrl() {
    return document.querySelector('meta[name="direct-upload-url"]')?.content || "/rails/active_storage/direct_uploads"
  }
}
